import React from 'react';
import {AdminPages} from "./AdminNav";

interface SidebarProps 
{
    items?
    authPages?
    onChange: (str: string) => void
}

class SidebarItems extends React.Component<SidebarProps, SidebarItems> {

    private routes = [
        {label: "Testing Check-in", value: "CheckIn"},
        {label: "Samples", value: "Samples"},
        {label: "Schedule Management", value: "Schedules"},
        {label: "Send Alert", value: "Alert"},
        {label: "Walk-in Form", value: "WalkinForm"},
        {label: "Receiving Labels", value: "RetrieveReceivingLabel"},
        {label: "Specimen Labels", value: "SpecimenLabel"},
        {label: "Machine Export", value: "MachineExport"},
        {label: "Facility", value: "Facility"},
        {label: "Rerun List", value: "RerunReport"},
        {label: "Batch Reporting", value: "BatchReporting"},
        {label: "Audit Logs", value: "AuditLogs"},
        {label: "User Management", value: "UserManagement"},
        {label: "Patient Management", value: "PatientManagement"},
        {label: "Samples Status", value: "ReconcileReport"},
        {label: "Reconcile Lab", value: "ReconcileLab"},
        {label: "Accessioning", value: "AccessionApp"},
        {label: "Rapid Test Management", value: "RapidTestManagement"},
        {label: "Test Management", value: "TestManagement"},
        {label: "Batch Management", value: "BatchManagement"},
        {label: "Services Management", value: "ServicesManagement"},
        {label: "Results Management", value: "ResultsManagement"},
        {label: "Communication Templates", value: "CommunicationTemplates"},
        {label: "Report Information", value: "ReportSettings"},
        {label: "Custom Fields", value: "CustomFields"},
        {label: "Password Requirements", value: "PasswordRequirements"},
        {label: "Internal Sample Generator", value: "InternalSampleGenerator"},
        {label: "File", value: "FileManagement"},
        {label: "Banner", value: "BannerManagement"},
    ]

    private patientPages = [AdminPages.CheckIn, AdminPages.WalkinForm, AdminPages.RapidTestManagement];
    private podPages = [AdminPages.Schedules, AdminPages.Alert];
    private samplePages = [AdminPages.Samples, AdminPages.InternalSampleGenerator];
    private labPages = [AdminPages.BatchReporting, AdminPages.SpecimenLabel, AdminPages.MachineExport, AdminPages.AccessionApp, AdminPages.RerunReport, AdminPages.BatchManagement];
    private reportPages = [AdminPages.AuditLogs, AdminPages.ReconcileReport, AdminPages.ReconcileLab];
    private receivingPages = [AdminPages.RetrieveReceivingLabel];
    private settingsPages = [AdminPages.ReportSettings, AdminPages.PasswordRequirements]
    private userManagementPages = [AdminPages.UserManagement, AdminPages.Facility, AdminPages.TestManagement,
        AdminPages.ServicesManagement, AdminPages.CommunicationTemplates, AdminPages.CustomFields, AdminPages.ResultsManagement, AdminPages.Banner, AdminPages.File];
    private patientMgmtPages = [AdminPages.PatientManagement]

    itemBelongsUnderTab(pageName, tabName){
        if(
            this.props.authPages.includes(pageName) &&
            tabName.includes(pageName)
        ){
            let route = this.routes.find(f => f.label === pageName)
            return (
                <li className={"sidebar-list-item"}>
                    <a className={'navSelect white'} href={`/admin/${route.value}`}
                       onClick={() => this.props.onChange(pageName)}>
                        {pageName}
                    </a>
                </li>
            );
        }

        return (<React.Fragment />);
    }

    render(){
        const buildAppointmentsTab = this.props.authPages.some(authPage => this.patientPages.includes(authPage));
        const buildPodsTab = this.props.authPages.some(authPage => this.podPages.includes(authPage));
        const buildLabsTab = this.props.authPages.some(authPage => this.labPages.includes(authPage));
        const buildReportsTab = this.props.authPages.some(authPage => this.reportPages.includes(authPage));
        const buildReceivingTab = this.props.authPages.some(authPage => this.receivingPages.includes(authPage));
        const buildUserMgmtTab = this.props.authPages.some(authPage => this.userManagementPages.includes(authPage));
        const buildSamplesTab = this.props.authPages.some(authPage => this.samplePages.includes(authPage));
        const buildSettingsTab = this.props.authPages.some(authPage => this.settingsPages.includes(authPage))
        const buildPatientsTab = this.props.authPages.some(authPage => this.patientMgmtPages.includes(authPage))

        return (
            <div className={"sidebar-wrapper"} >
                {/* <a data-toggle="collapse" aria-expanded="false" className={"navTag primary-black-bg"}>
                    <img src={"https://storage.googleapis.com/streamline-bucket/FullLogoWhite.png"} 
                        className={"sidebar-logo"} 
                        alt={"logo"}/>
                </a> */}

                <ul className={"list-unstyled"} id={"menu"}>
                    { buildAppointmentsTab ?
                        <li className={"sidebar-header"} id={"patients-list"}>
                            <a href={'#!'} className={"navTag white"} id={"patients-tab"}>
                                <span className='navIconWrapper'>
                                    <img src={"https://storage.googleapis.com/streamline-bucket/appointment.png"} alt="" className='navIcon'/>
                                </span>
                                Appointments
                                <i id={"patients-caret"} className="fa fa-xs fa-caret-down nav-caret"/>
                            </a>
                            <ul className={"list-unstyled"}>
                                {this.props.items.map( t => {
                                    return this.itemBelongsUnderTab(t, this.patientPages)
                                })}
                            </ul>
                        </li> :
                        <React.Fragment />
                    }
                    { buildPodsTab ?
                        <li className={"sidebar-header"} id={"pods-list"}>
                            <a href={'#!'} className={"navTag primary-black-bg white"} id={"pods-tab"}>
                                <span className='navIconWrapper'>
                                    <img src={"https://storage.googleapis.com/streamline-bucket/pods.png"} alt="" className='navIcon'/>
                                </span>
                                Schedules
                                <i id={"pods-caret"} className="fa fa-xs fa-caret-down nav-caret"/>
                            </a>
                            <ul className={"list-unstyled"}>
                                {this.props.items.map( t => {
                                    return this.itemBelongsUnderTab(t, this.podPages)
                                })}
                            </ul>
                        </li> :
                        <React.Fragment />
                    }
                    { buildSamplesTab ?
                        <li className={"sidebar-header"} id={"samples-list"}>
                            <a href={"#!"} className={"navTag primary-black-bg white"} id={"samples-tab"}>
                                <span className='navIconWrapper'>
                                    <img src={"https://storage.googleapis.com/streamline-bucket/samples.png"} alt="" className='navIcon'/>
                                </span>
                                Samples
                                <i id={"samples-caret"} className="fa fa-xs fa-caret-down nav-caret"/>
                            </a>
                            <ul className={"list-unstyled"}>
                                {this.props.items.map( t => {
                                    return this.itemBelongsUnderTab(t, this.samplePages)
                                })}
                            </ul>
                        </li> :
                        <React.Fragment />
                    }
                    { buildPatientsTab  ?
                        <li className={"sidebar-header"} id={"patients-list"}>
                            <a href={'#!'} className={"navTag white"} id={"patients-tab"}>
                                <span className='navIconWrapper'>
                                    <img src={"https://storage.googleapis.com/streamline-bucket/people.png"} alt="" className='navIcon'/>
                                </span>
                                    Patients 
                                <i id={"patients-caret"} className="fa fa-xs fa-caret-down nav-caret"/>
                            </a>
                            <ul className={"list-unstyled"}>
                                {this.props.items.map( t => {
                                    return this.itemBelongsUnderTab(t, this.patientMgmtPages)
                                })}
                            </ul>
                        </li> :
                        <React.Fragment />
                    }
                    { buildLabsTab ?
                        <li className={"sidebar-header"} id={"lab-list"}>
                            <a href={'#!'} className={"navTag primary-black-bg white"} id={"lab-tab"}>
                                <span className='navIconWrapper'>
                                    <img src={"https://storage.googleapis.com/streamline-bucket/lab.png"} alt="" className='navIcon'/>
                                </span>
                                Lab
                                <i id={"lab-caret"} className="fa fa-xs fa-caret-down nav-caret"/>
                            </a>
                            <ul className={"list-unstyled"}>
                                {this.props.items.map( t => {
                                    return this.itemBelongsUnderTab(t, this.labPages)
                                })}
                            </ul>
                        </li> :
                        <React.Fragment />
                    }
                    { buildReportsTab ?
                        <li className={"sidebar-header"} id={"reports-list"}>
                            <a href={'#!'} className={"navTag primary-black-bg white"} id={"reports-tab"}>
                                <span className='navIconWrapper'>
                                    <img src={"https://storage.googleapis.com/streamline-bucket/report.png"} alt="" className='navIcon'/>
                                </span>
                                Reports
                                <i id={"reports-caret"} className="fa fa-xs fa-caret-down nav-caret"/>
                            </a>
                            <ul className={"list-unstyled"}>
                                {this.props.items.map( t => {
                                    return this.itemBelongsUnderTab(t, this.reportPages)
                                })}
                            </ul>
                        </li> :
                        <React.Fragment />
                    }
                    { buildReceivingTab ?
                        <li className={"sidebar-header"} id={"receiving-list"}>
                            <a href={'#!'} className={"navTag primary-black-bg white"} id={"receiving-tab"}>
                                <span className='navIconWrapper'>
                                    <img src={"https://storage.googleapis.com/streamline-bucket/receiving.png"} alt="" className='navIcon'/>
                                </span>
                                Receiving
                                <i id={"receiving-caret"} className="fa fa-xs fa-caret-down nav-caret"/>
                            </a>
                            <ul className={"list-unstyled"}>
                                {this.props.items.map( t => {
                                    return this.itemBelongsUnderTab(t, this.receivingPages)
                                })}
                            </ul>
                        </li> :
                        <React.Fragment />
                    }
                    { buildUserMgmtTab ?
                        <li className={"sidebar-header"} id={"user-mgmt-list"}>
                            <a href={'#!'} className={"navTag primary-black-bg white"} id={"user-mgmt-tab"}>
                                <span className='navIconWrapper'>
                                    <img src={"https://storage.googleapis.com/streamline-bucket/setup.png"} alt="" className='navIcon'/>
                                </span>
                                Setup
                                <i id={"user-mgmt-caret"} className="fa fa-xs fa-caret-down nav-caret"/>
                            </a>
                            <ul className={"list-unstyled"}>
                                {this.props.items.map( t => {
                                    return this.itemBelongsUnderTab(t, this.userManagementPages)
                                })}
                            </ul>
                        </li> :
                        <React.Fragment />
                    }
                    { buildSettingsTab ?
                        <li className={"sidebar-header"} id={"user-mgmt-list"}>
                            <a href={'#!'} className={"navTag primary-black-bg white"} id={"user-mgmt-tab"}>
                                <span className='navIconWrapper'>
                                    <img src={"https://storage.googleapis.com/streamline-bucket/settings.png"} alt="" className='navIcon'/>
                                </span>
                                Settings
                                <i id={"user-mgmt-caret"} className="fa fa-xs fa-caret-down nav-caret"/>
                            </a>
                            <ul className={"list-unstyled"}>
                                {this.props.items.map( t => {
                                    return this.itemBelongsUnderTab(t, this.settingsPages)
                                })}
                            </ul>
                        </li> :
                        <React.Fragment />
                    }

                </ul>
            </div>
        );
    }
}

export default SidebarItems